import React, { useContext } from 'react';
import { Link, useHistory } from 'react-router-dom';
import loadable from '@loadable/component';
import styled from 'styled-components';
import { QueryClient } from 'react-query';

import { tc, ts } from 'utils/theme';
import { destroyLocalAuth } from 'utils/auth';
import { clearUserMetadata } from '../../../utils/datadog';

import { AppContext } from 'contexts/AppContext';
import { logoutFusionAuthUser } from 'services/fusionAuthService';

const Logo = loadable(() => import('components/Atoms/Logo'));
const Icon = loadable(() => import('components/Atoms/Icon'));

const StyledHeader = styled.header`
  border-bottom: ${(p) => `1px solid ${tc('borderColor')(p)}`};
  display: grid;
  grid-column-gap: 5px;
  grid-template-columns: 35px 1fr 35px;
  height: 100%;
  padding: 5px ${ts('contentPadding')};
  place-items: center;
  position: relative;
  width: 100%;
`;

const AppHeaderLogo = styled(Logo)`
  display: block;
  height: 100%;
  width: 100%;
  max-width: 60vw;
  text-align: center;
`;

const HomeButton = styled(Link)`
  color: ${tc('appBlack')};
  display: block;
  height: 35px;
  text-align: center;
  text-decoration: none;
  width: 35px;
`;

const LogoutButton = styled.button`
  background: none;
  border: none;
  color: ${tc('appBlack')};
  cursor: pointer;
  display: block;
  padding: 0;
  position: relative;
  margin: 0;
  height: 35px;
  width: 35px;
`;

const HomeIcon = styled(Icon)`
  font-size: 35px;
`;

const LogoutIcon = styled(Icon)`
  font-size: 35px;
  position: absolute;
  top: 0;
  left: 5px;
`;

const AppHeader = () => {
  const { organizationId, propertyId, authenticationPortal } =
    useContext(AppContext);
  const history = useHistory();
  const queryClient = new QueryClient();

  const logoutUser = async () => {
    clearUserMetadata();
    if (authenticationPortal) {
      queryClient.clear();
      return logoutFusionAuthUser();
    }
    queryClient.clear();
    destroyLocalAuth();
    return history.push(`/${organizationId}/${propertyId}`);
  };

  return (
    <StyledHeader>
      <HomeButton to={`/${organizationId}/${propertyId}/`}>
        <HomeIcon iconName="et-home" />
      </HomeButton>
      <AppHeaderLogo />
      <LogoutButton onClick={logoutUser}>
        <LogoutIcon iconName="et-logout" />
      </LogoutButton>
    </StyledHeader>
  );
};

export default AppHeader;
